<template>
  <button
    type="button"
    :class="['moz-search-button', btnClasses]"
    @click="onClick"
  >
    <span class="icon-search">
      <icon-search />
    </span>
    <slot />
  </button>
</template>

<script>
import IconSearch from './IconSearch';

export default {
  name: 'MozSearchBtn',
  components: {
    IconSearch,
  },
  props: {
    disabled: Boolean,
  },
  computed: {
    btnClasses() {
      return {
        _disabled: this.disabled,
      };
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.moz-search-button {
  padding: 15px 43px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(55, 63, 71, .05);
  border: solid 1px #fabe31;
  background-color: #fabe31;
  cursor: pointer;

  &:hover {
    border: solid 1px #dba525;
    background-color: #dba525;
  }

  &._disabled {
    color: #c3c3c3;
    border: solid 1px #c3c3c3;
    background-color: #e6e6e6;
    pointer-events: none;
    user-select: none;
  }
}

.icon-search {
  display: inline-block;
  width: 13px;
  height: 13px;
  margin-right: 3px;
  cursor: pointer;
  vertical-align: baseline;
  transform: scale(-1, 1);

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
}
</style>
